import { ref } from 'vue'

const showModal = ref(false)
const isVideo = ref(false)
const urlValue = ref('')
const isEmbedded = ref(false)

export function useModal() {
  const openModal = ({ video = false, url = '', embedded = false }) => {
    isVideo.value = video
    urlValue.value = url
    isEmbedded.value = embedded
    showModal.value = true
  }

  const closeModal = () => {
    showModal.value = false
  }

  return {
    showModal,

    isVideo,
    urlValue,
    isEmbedded,
    openModal,
    closeModal,
  }
}
